var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8646 4.82657C7.49081 2.67161 9.74996 1 12 1C14.25 1 16.5092 2.67161 18.1354 4.82657C19.7967 7.02808 21 9.98463 21 13C21 15.9247 20.2389 18.4349 18.6762 20.2281C17.0969 22.0402 14.8029 23 12 23C9.19711 23 6.90307 22.0402 5.32379 20.2281C3.76106 18.4349 3 15.9247 3 13C3 9.98463 4.20327 7.02808 5.8646 4.82657ZM7.46105 6.0313C6.01383 7.94907 5 10.4925 5 13C5 15.5982 5.67584 17.5879 6.83156 18.9141C7.97073 20.2212 9.67669 21 12 21C14.3233 21 16.0293 20.2212 17.1684 18.9141C18.3242 17.5879 19 15.5982 19 13C19 10.4925 17.9862 7.94907 16.539 6.0313C15.0566 4.06697 13.3158 3 12 3C10.6842 3 8.94339 4.06697 7.46105 6.0313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteins);
export default __webpack_public_path__ + "static/media/proteins.8281f961cdac841263726d0bb7d28a3d.svg";
export { ForwardRef as ReactComponent };